import React, { Component } from "react";
import request, { tracesDirectUrl, tracesToken } from "../../lib/requester";
import _ from "lodash";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Link } from "react-router-dom";
import moment from "moment";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import axios from "axios";
import Autocomplete from "../../component/autocomplete";

// Component
import GeneralInfo from "../../component/generalinfo";
import CustomerInfo from "../../component/customerinfo";
import Reason from "../../component/reason";

import * as Minio from "minio";
import { Modal, Button } from "antd";
import { DownloadOutlined, DeleteOutlined } from "@ant-design/icons";

const minioClient = new Minio.Client({
  endPoint: "s3.dexagroup.com",
  accessKey: "aam-traces",
  secretKey: "BkwJ0bdaNaSPl44tzxwC01Z6nsAM!U",
});

class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      additionalAttachment: 0,
      program_customer_id: "",
      lovSupplierSite: [],
      lovSupplier: [],
      supplier: "",
      supplierId: 0,
      supplierSite: 0,
      orgInitital: "",
      orgId: "",
      skbNumber: "",
      programCustId: "",
      totalSelectedAmount: 0,
      reason: "",
      accOwner: "",
      bankName: "",
      showSkbAttachment: false,
      skb: "N",
      taxNo: "",
      taxDate: new Date(),
      npwp: "",
      norek: "",
      paymentMethod: "",
      loading: false,
      principalName: "",
      description: "",
      refNumber: "",
      programType: "",
      customerName: "",
      potongTagihan: "",
      pphRate: 0,
      pphType: "",
      dpp: 0,
      ppn: 0,
      pph: 0,
      totalAmount: 0,
      docs: [],
      fileContainer: [],
      error: [],
      success: "",
      branchId: "",
      customerId: "",
      listInvoice: [],
      selectedInvoice: [],
      fileSKB: { filename: "", path: "" },
      fileLain: { filename: "", path: "" },
      fileTambahan: { filename: "", path: "" },
      fileRequired: { filename: "", path: "" },
      lovPPH: [],
      user: JSON.parse(window.localStorage.getItem("is_user")) || {},
      submitteddate: "",
      startDate: new Date(),
      endDate: new Date(),
      sisabudget: 0,
      programNumber: "",
      budgetType: "",
      program_budget: 0,
      assign_budget: 0,
      sales_target: 0,
      skpnumber: "",
      claimnumber: "",
      kwitansi: "",
      header_npwp: "",
      header_npwp_name: "",
      header_npwp_address: "",
      documentList: [],
      docsContainer: [],
      productList: [],
      general_claim_number: '',
      general_skp_number: '',
      general_program_number: '',
      general_principal: '',
      general_reff_number: '',
      general_program_type: '',
      general_description: '',
      general_program_submitted_date: '',
      general_program_start_date: '',
      general_program_end_date: '',
      general_claim_exp_date: '',
      general_budget_type: '',
      general_budget: '',
      general_budget_assigned: '',
      general_sales_target: '',
      general_customer_pph_type: '',
      general_customer_pph_rate: '',
      customer_name: '',
      customer_npwp_no: '',
      customer_npwp_address: '',
      customer_npwp_name: '',
      newFile: '',
      objUlr: '',
      newAdditionalFile: '',
      objUrlAdditional: ''
    };
  }

  componentDidMount = () => {
    this.getDetailProgram();
    this.getPPHType();
  };

  setGeneralInfo = (header) => {
    this.setState({
      general_claim_number: header.claim_number,
      general_skp_number: header.skp_number,
      general_program_number: header.program_number,
      general_principal: header.org_name,
      general_reff_number: header.ref_number,
      general_program_type: header.program_name,
      general_description: header.description,
      general_program_submitted_date: moment(header.creation_date).format("DD-MMM-YYYY"),
      general_program_start_date: moment(header.start_date).format("DD-MMM-YYYY"),
      general_program_end_date: moment(header.end_date).format("DD-MMM-YYYY"),
      general_claim_exp_date: moment(header.claim_exp_date).format("DD-MMM-YYYY"),
      general_budget_type: header.budget_type,
      general_budget: header.program_budget,
      general_budget_assigned: header.assign_budget,
      general_sales_target: header.sales_target,
      general_customer_pph_type: header.pph_type,
      general_customer_pph_rate: header.pph_rate,
    })
  }

  setCustomerInfo = (customer, data_npwp) => {
    this.setState({
      customer_npwp_name: customer.name,
      customer_npwp_address: customer.address,
      customer_npwp_no: data_npwp ? data_npwp : customer.npwp
    })

    let app = this
    window.setTimeout(() => { console.log(app.state) }, 200)
  }

  getInvoice = () => {
    let url = "/api/orafin/v1/claim/list-invoice";
    let param = {
      branchId: this.state.branchId,
      customerId: this.state.customerId,
    };
    request.postOracle(url, param, {
      success: function (response) {
        console.log("invoice result");
        let invoice = response.data.data;
        invoice = invoice.map((item, index) => {
          item.ADJUST = item.OUTSTANDING_AMOUNT;
          return item;
        });
        this.setState({ listInvoice: invoice });
        this.calculateCheckedInvoice();
      }.bind(this),
      error: function (e) {
        console.log("invoice", e);
      },
    });
  };

  getNpwp = (data_npwp) => {
    let url = "/api/orafin/v1/general/npwp-customer";
    let param = { customerid: this.state.customerId, branchId: this.state.branchId };
    this.setState({ loading: true });
    request.postOracle(url, param, {
      success: function (response) {
        let { data } = response.data;

        this.setCustomerInfo(data, data_npwp)
        this.setState({
          // npwp: data.npwp,
          npwp: this.state.npwp.length > 0 ? this.state.npwp : data.npwp,
          header_npwp: data_npwp ? data_npwp : data.npwp,
          header_npwp_name: data.name,
          header_npwp_address: data.address,
          loading: false,
        });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  getDetailProgram = () => {
    let url = "/api/traces/v1/claim/detail-by-claimid";
    let { id } = this.props.match.params;
    let param = {
      claim_id: id,
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        let {
          header,
          claim,
          attachment,
          invoice,
          document,
          product,
          npwp
        } = response.data.data;
        let invoiceContainer = invoice.map((item, index) => {
          item.INVOICE_AMOUNT = item.invoice_amount;
          item.INVOICE_NUMBER = item.invoice_number;
          item.CUSTOMER_TRX_ID = item.invoice_id;
          item.INVOICE_DATE = item.invoice_date;
          return item;
        });

        let documentList = [];
        document.forEach((item, index) => {
          documentList.push({ program_doc_id: item.program_doc_id });
        });
        console.log(documentList)

        // Mandatory Document
        if (claim.doc_mandatory_filename) {
          attachment.push({
            document_name: "",
            path: claim.doc_mandatory_path || "",
            filename: claim.doc_mandatory_filename || "",
          });
        }

        // Additional Document
        if (claim.doc_tambahan_filename) {
          attachment.push({
            document_name: "Additional Document",
            path: claim.doc_tambahan_path || "",
            filename: claim.doc_tambahan_filename || "",
          });
          // document.push({
          //   document_name: "Additional Document",
          //   path: claim.doc_tambahan_path || "",
          //   filename: claim.doc_tambahan_filename || "",
          // });
        }
        let newDocs = document;
        let newAttach = attachment;

        this.setGeneralInfo(header)
        this.setState({
          customer_name: header.customer_name,
          kwitansi: header.kwitansi,
          claimnumber: header.claim_number,
          programNumber: header.program_number,
          budgetType: header.budget_type,
          skpnumber: header.skp_number,
          sisabudget: header.sisa_budget,
          program_budget: header.program_budget,
          assign_budget: header.assign_budget,
          sales_target: header.sales_target,
          program_customer_id: header.program_customer_id,
          orgId: header.org_id,
          orgInitital: header.org_initial,
          supplier: claim.aam_vendor_name,
          supplierId: claim.aam_vendor_id,
          supplierSite: claim.aam_vendor_site_id,
          selectedInvoice: invoiceContainer,
          loading: false,
          branchId: header.branch_id,
          customerId: header.customer_id,
          bankName: claim.bank,
          accOwner: claim.bank_acc_owner,
          principalName: header.org_name,
          refNumber: header.ref_number,
          programType: header.program_name,
          description: header.description,
          customerName: header.customer_name || "",
          dpp: this.thousandSeparator(claim.dpp || 0),
          ppn: this.thousandSeparator(claim.ppn || 0),
          pph: this.thousandSeparator(claim.pph || 0),
          showSkbAttachment: claim.skb === "Y" ? true : false,
          pphRate: claim.pph_rate,
          pphType: claim.pph_type,
          potongTagihan: claim.potong_tagihan,
          // docs: attachment,
          docs: document,
          documentList: documentList,
          productList: product,

          listInvoice: invoice,
          submitteddate: moment(header.creation_date).format("DD-MMM-YYYY"),
          claimExpDate: moment(header.claim_exp_date).format("DD-MMM-YYYY"),
          startDate: moment(header.start_date).format("DD-MMM-YYYY"),
          endDate: moment(header.end_date).format("DD-MMM-YYYY"),
          paymentMethod: claim.payment_method,
          npwp: claim.npwp,
          norek: claim.no_rekening,
          skb: claim.skb,
          taxNo: claim.tax_no,
          reason: header.reason_reject,
          taxDate: new Date(claim.tax_date),
          fileSKB: {
            filename: claim.doc_skb_filename,
            path: claim.doc_skb_path,
          },
          fileLain: {
            filename: claim.doc_lain_filename,
            path: claim.doc_lain_path,
          },
          fileTambahan: {
            filename: claim.doc_tambahan_filename,
            path: claim.doc_tambahan_path,
            key: claim.doc_mandatory_file_key,
            claim_id: claim.claim_id,
            doc: 'aditional'
          },
          fileRequired: {
            filename: claim.doc_mandatory_filename,
            path: claim.doc_mandatory_path,
            key: claim.doc_mandatory_file_key,
            claim_id: claim.claim_id,
            doc: 'mandatory',
            claim_number: header.claim_number
          },
          reason: header.reason_reject,
          submitteddate: moment(header.creation_date).format("DD-MMM-YYYY"),
          claimExpDate: moment(header.claim_exp_date).format("DD-MMM-YYYY"),
          startDate: moment(header.start_date).format("DD-MMM-YYYY"),
          endDate: moment(header.end_date).format("DD-MMM-YYYY"),
          header_npwp: npwp ? npwp.NPWP_NUMBER : '',
          header_npwp_name: npwp ? npwp.NPWP_NAME : '',
          header_npwp_address: npwp ? npwp.NPWP_ADDRESS : '',
        });
        this.getInvoice();
        this.getSupplierSite(claim.aam_vendor_id);
        // this.getNpwp(claim.npwp);
        this.state.productList.forEach((item, index) => {
          item.item_actual_formatted = item.item_actual;
          item.item_actual = this.removeSeparator(item.item_actual);
        });
        let app = this;
        window.setTimeout(() => {
          app.calculateAmount();
          app.calculateCheckedInvoice();
        }, 200);
      }.bind(this),
      error: function (e) {
        console.log(e);
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  getPPHType = () => {
    let url = "/api/traces/v1/general/pph-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovPPH: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  //   editProduct = (index) => {
  //     let el = document.getElementById("search-" + index);
  //     el.value = "";

  //     this.setState({ supplier: "", supplierId: 0 });
  //   };
  onSelectSupplier = (item, index) => {
    this.setState({ supplier: item.text, supplierId: item.value });
    this.getSupplierSite(item.value);
  };

  getSupplierSite = (id) => {
    if (!id || id.length === 0) {
      return false;
    }
    let url = "/api/orafin/v1/claim/list-supplier-site";
    let param = { supplier_id: id };
    this.setState({ loading: true });
    request.postOracle(url, param, {
      success: function (response) {
        let { data } = response.data;
        let lovSupplierSite = [];
        data.forEach((item, index) => {
          lovSupplierSite.push({
            SUPPLIER_SITE_CODE: item.VENDOR_SITE_CODE,
            SUPPLIER_SITE_ID: item.VENDOR_SITE_ID,
          });
        });
        this.setState({ lovSupplierSite: lovSupplierSite, loading: false });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  onChangeAutocomplete = (q) => {
    let param = {
      supplier_name: q,
    };
    return new Promise((resolve, reject) => {
      request.postOracle("/api/orafin/v1/claim/list-supplier", param, {
        success: function (response) {
          let { data } = response.data;
          let lovSupplier = [];
          data.forEach((item, index) => {
            // [0] supplier name [1] supplier id
            lovSupplier.push({ text: item.VENDOR_NAME, value: item.VENDOR_ID });
          });
          resolve(lovSupplier);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });
  };

  renderNorek = () => {
    if (this.state.paymentMethod === "TRF") {
      // if (this.state.orgInitial === 'AAM') {
      if (1 === 1) {
        return (
          <div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
                Supplier
              </label>
              <div className="col-sm-8">
                <Autocomplete
                  onchange={this.onChangeAutocomplete.bind(this)}
                  isDisabled={this.state.supplier && this.state.supplier.length > 0 ? true : false}
                  currentvalue={this.state.supplier}
                  currentIndex={0}
                  principalCode={this.state.user.orgInitial}
                  onselect={this.onSelectSupplier.bind(this)}
                />
              </div>
            </div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
                Supplier Site
              </label>
              <div className="col-sm-8">
                <select
                  className="form-control"
                  value={this.state.supplierSite}
                  name="supplierSite"
                  onChange={this.handleChangeInput.bind(this)}
                >
                  <option value="">- Select Supplier Site -</option>
                  {this.state.lovSupplierSite.map((item, index) => (
                    <option value={item.SUPPLIER_SITE_ID}>
                      {item.SUPPLIER_SITE_CODE}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
                Account No
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  id="inputEmail3"
                  name="norek"
                  placeholder="Account No"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.norek}
                />
              </div>
            </div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
                Bank Name
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  id="inputEmail3"
                  name="bankName"
                  placeholder="Bank Name"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.bankName}
                />
              </div>
            </div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
                Account Owner
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  id="inputEmail3"
                  name="accOwner"
                  placeholder="Account Owner"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.accOwner}
                />
              </div>
            </div>
          </div>
        );
      }
    }
  };

  renderLovPPh = () => {
    return (
      <select
        // disabled
        className="form-control"
        name="pphType"
        value={this.state.pphType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Type -</option>
        {this.state.lovPPH.map((item, index) => (
          <option value={item.pph_type} key={index}>
            {item.pph_type}
          </option>
        ))}
      </select>
    );
  };

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fas fa-check"></i> {this.state.success}
        </div>
      );
    }
  };

  thousandSeparator = (value) => {
    value = value ? value.toString() : "0";
    value = value.replace(/,/g, "").replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  removeSeparator = (value) => {
    if (value.length === 0) return 0;
    value = value.toString();
    return value.replace(/,/g, "");
  };

  calculateAmount = () => {
    let { dpp, ppn, pph, totalAmount } = this.state;
    totalAmount =
      (parseFloat(this.removeSeparator(dpp)) || 0) +
      (parseFloat(this.removeSeparator(ppn)) || 0) -
      (parseFloat(this.removeSeparator(pph)) || 0);
    totalAmount = Math.round(totalAmount);
    this.setState({
      totalAmount: this.thousandSeparator(totalAmount),
      ppn: this.thousandSeparator(ppn),
    });
  };

  handleChangeInputNpwp = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    // this.state.npwp = value;
    this.state.header_npwp = value;
  };

  handleChangeNPWP = value => {
    console.log(value)
    this.setState({
      header_npwp: value,
      customer_npwp_no: value
    })
  }

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    if (name === "pph" || name === "ppn" || name === "dpp") {
      value = this.thousandSeparator(value);
    } else if (name === "pphRate") {
      value = value.replace(/[^0-9.]/g, "").replace(/\./g, "");
      if (parseInt(value) > 100) value = 100;
      if (parseInt(value) < 0) value = 0;
    }

    this.setState({ [name]: value });
    if (
      name === "pph" ||
      name === "ppn" ||
      name === "dpp" ||
      name === "pphRate"
    ) {
      let app = this;
      if (name === "dpp") {
        let ppn = this.thousandSeparator(
          parseInt(this.removeSeparator(value)) / 10
        );
        app.setState({ ppn: ppn });
        window.setTimeout(() => {
          app.countPPH();
        }, 100);
      } else if (name === "pphRate") {
        window.setTimeout(() => {
          app.countPPH();
        }, 100);
      }
      window.setTimeout(() => {
        app.calculateAmount();
        app.forceUpdate();
      }, 100);
    }
  };

  countPPH = () => {
    let { dpp, pphRate } = this.state;
    pphRate = pphRate.length === 0 ? 0 : pphRate;
    let pph = this.thousandSeparator(
      (parseInt(pphRate || 0) / 100) * parseInt(this.removeSeparator(dpp))
    );
    this.setState({ pph: pph });
  };

  renderDocument = () => {
    return this.state.docs.map((item, index) => (
      <div className="row mb-2" key={index}>
        <div className="col-md-2 mt-2">{item.document_name}</div>
        <div className="col-md-3">
          <input
            type="file"
            className="form-control"
            data-index={index}
            data-program-doc-id={item.program_doc_id}
            onChange={this.handleUpload.bind(this)}
          />
        </div>
        <div className="col-md-6 mt-2">{this.renderUploadedFile(item)}</div>
      </div>
    ));
  };

  renderProduct = () => {
    // console.log(this.state.productList);
    return this.state.productList.map((item, index) => (
      <div className="row mb-2" key={index}>
        <div className="col-sm-3">
          <input
            disabled
            type="text"
            className="form-control"
            name="productname"
            value={item.item_description}
          />
        </div>
        <div className="col-sm-2">
          <input
            disabled
            type="text"
            className="form-control"
            name="itemReff"
            value={item.item_reff}
          />
        </div>
        <div className="col-sm-2">
          <input
            disabled
            type="text"
            className="form-control"
            name="itemBudget"
            // value={item.item_budget}
            value={
              item.item_budget
                ? item.item_budget.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
                : 0
            }
          />
        </div>
        <div className="col-sm-2">
          <input
            type="text"
            className="form-control"
            name="itemActual"
            currentIndex={index}
            value={item.item_actual_formatted}
            // currentvalue={item.item_actual_formatted}
            placeholder="actual"
            defaultValue={item.item_actual}
            onChange={this.onChangeProductActual.bind(this)}
          />
        </div>
      </div>
    ));
  };

  replicateProduct = () => {
    let { productList } = this.state;
    productList.push({
      item_id: "",
      item_desc: "",
      item_reff: "",
      item_budget: "",
    });
    this.setState(productList);
  };

  removeProduct = (index) => {
    if (
      this.state.productList.length === 1 ||
      this.state.productContainer.length === 1
    ) {
      alert("You must have at least 1 product");
      return false;
    }
    let { productList, productContainer } = this.state;
    productList.splice(index, 1);
    productContainer.splice(index, 1);
    this.setState(productList);
    this.setState(productContainer);
    this.renderProduct();
    window.setTimeout(
      function () {
        console.log(this.state.productContainer);
        console.log(this.state.productList);
      }.bind(this),
      200
    );
  };

  onChangeProductActual = (event) => {
    let value = event.target.value;
    let currentIndex = event.target.attributes.getNamedItem("currentIndex")
      .value;

    let { productList } = this.state;
    productList[currentIndex].item_actual = this.removeSeparator(value);
    productList[currentIndex].item_actual_formatted = this.thousandSeparator(
      value
    );
    this.setState(productList);

    let app = this;
    window.setTimeout(() => {
      console.log(app.state.productList);
    }, 100);
  };

  onChangeProductBudget = (event) => {
    let value = event.target.value;
    let currentIndex = event.target.attributes.getNamedItem("currentIndex")
      .value;

    let { productList } = this.state;
    productList[currentIndex].item_budget = this.removeSeparator(value);
    productList[currentIndex].item_budget_formatted = this.thousandSeparator(
      value
    );
    this.setState(productList);

    let app = this;
    window.setTimeout(() => {
      console.log(app.state.productList);
    }, 100);
  };

  handleUpload = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files[0];
    let { programDocId, index } = e.target.dataset;
    // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = [
      "jpg",
      "png",
      "jpeg",
      "gif",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "csv",
      "pdf",
    ];
    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);
    this.setState({ loading: true });
    request.postnobodyTraces("/api/traces/v1/general/upload-file", data, {
      success: function (response) {
        let data = response.data;
        let container = this.state.fileContainer;
        data.program_doc_id = programDocId;
        data.index = index;
        data.path = data.fullurl;
        container.push(data);

        let findIndex = _.findIndex(this.state.docs, function (o) {
          return parseInt(o.program_doc_id) === parseInt(programDocId);
        });
        console.log(findIndex);
        let { docs } = this.state;
        if (findIndex >= 0) {
          docs[findIndex].filename = data.filename;
          //   docs[findIndex].path = data.path;
          docs[findIndex].path = data.fullurl;
          this.setState(docs);
        }
        this.setState({ fileContainer: container, loading: false });
        this.forceUpdate();
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      },
    });
  };

  handleUploadSingle = async (e) => {
    // if (e.target.files.length === 0) {
    //   return false;
    // }

    this.setState({ loading: true });

    let files = e.target.files[0];
    let doctype = e.target.dataset.type;
    // // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = [
      "jpg",
      "png",
      "jpeg",
      "gif",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "csv",
      "pdf",
    ];


    if (doctype === "TAMBAHAN") {
      this.setState({
        newAdditionalFile: e.target.files[0],
        objUrlAdditional: URL.createObjectURL(e.target.files[0])
      })
    } else if (doctype === "REQUIRED") {
      this.setState({
        newFile: e.target.files[0],
        objUlr: URL.createObjectURL(e.target.files[0])
      })
    }

    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);

    const presignedUrl = async (fileName) => {
      try {
        const policy = minioClient.newPostPolicy();
        policy.setKey(fileName);
        policy.setBucket("aam-traces");

        const expires = new Date();
        expires.setSeconds(24 * 60 * 60 * 10); // 10 days expiry.
        policy.setExpires(expires);
        return await minioClient.presignedPostPolicy(policy);
      } catch (error) {
        console.log(error);
        this.setState({ loading: true });
        this.warning("Failed code : Failed create presign URL")
      }
    };

    const uploadToS3 = async (obj, file) => {
      try {
        const formData = new FormData();
        Object.entries(obj.formData).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append("file", file);

        return await axios.post(obj.postURL, formData);
      } catch (error) {
        this.setState({ loading: true });
        console.log("upload s3 : ", error);
        this.warning("Failed code : Failed upload to S3 after create presign URL")
      }
    };

    try {
      let claim_no = this.state.skpnumber.split("-");
      let folder = doctype === "SKB" ? 'skb'
        : doctype === "LAIN" ? 'lain'
          : doctype === "TAMBAHAN" ? 'additional'
            : doctype === "REQUIRED" ? "mandatory" : ''
      const fileNameToMinio = `/${folder}/${filename}`;
      const minioUrl = await presignedUrl(fileNameToMinio);
      const uploadFilePdf = await uploadToS3(minioUrl, files);

      if (uploadFilePdf?.status === 204) {
        if (doctype === "SKB") {
          let { fileSKB } = this.state;
          fileSKB.filename = filename;
          fileSKB.path = minioUrl.formData.key;
          this.setState(fileSKB);
        } else if (doctype === "LAIN") {
          let { fileLain } = this.state;
          fileLain.filename = filename;
          fileLain.path = minioUrl.formData.key;
          this.setState(fileLain);
        } else if (doctype === "TAMBAHAN") {
          let { fileTambahan } = this.state;
          fileTambahan.filename = filename;
          fileTambahan.path = minioUrl.formData.key;
          this.setState(fileTambahan);
        } else if (doctype === "REQUIRED") {
          let { fileRequired } = this.state;
          fileRequired.filename = filename;
          fileRequired.path = minioUrl.formData.key;
          this.setState(fileRequired);
        }
        this.setState({ loading: false });
        this.success()
      } else {
        this.setState({ loading: false, error: ["Failed to submit"] });
        this.warning("Failed code")
      }
    } catch (error) {
      this.setState({ loading: false, error: ["Failed to submit"] });
      this.warning("Failed. please try again")
    }
  };

  success = () => {
    Modal.success({
      title: "Success",
      content: "Success Upload",
      onOk() {
        // setData([]);
      },
    });
  };

  warning = (message) => {
    Modal.warning({
      title: "Failed",
      content: message,
      onOk() {
        // setData([]);
      },
    });
  };

  renderUploadedFile = (item) => {
    if (item.filename.length > 0) {
      return (
        <span>
          <Link to={{ pathname: item.path }} target="_blank">
            {item.filename}
          </Link>
          &nbsp;
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => this.removeFile(item)}
          >
            <i className="fas fa-trash-alt"></i>
          </button>
        </span>
      );
    }
  };

  removeFileAdditional = (type) => {
    if (type === "lain") {
      let { fileLain } = this.state;
      fileLain.filename = "";
      fileLain.path = "";
      this.setState(fileLain);
    } else if (type === "tambahan") {
      let { fileTambahan } = this.state;
      fileTambahan.filename = "";
      fileTambahan.path = "";
      this.setState(fileTambahan);
    }
  };

  removeFile = (item) => {
    let program_doc_id = item.program_doc_id;
    let indexing = _.findIndex(this.state.docs, function (o) {
      return parseInt(o.program_doc_id) === parseInt(program_doc_id);
    });
    let { docs } = this.state;
    docs[indexing].filename = "";
    docs[indexing].path = "";
    this.setState(docs);
  };

  validateForm = () => {
    let {
      ppn,
      paymentMethod,
      npwp,
      header_npwp,
      pphType,
      dpp,
      totalAmount,
      docs,
      selectedInvoice,
      bankName,
      accOwner,
      taxDate,
      taxNo,
      documentList,
      productList,
    } = this.state;
    let error = [];
    if (parseInt(this.removeSeparator(ppn)) > 0) {
      if (taxDate.length === 0) {
        error.push("Tax Date is empty");
      }
      if (taxNo.length === 0) {
        error.push("Tax No is empty");
      }
    }
    if (paymentMethod.length === 0) {
      error.push("Please select payment method");
    }
    if (!header_npwp || header_npwp.length === 0) {
      error.push("NPWP is empty");
    }
    if (!pphType || pphType === "") {
      error.push("Please select PPh Type");
    }
    if (parseInt(dpp) === 0 || dpp.length === 0) {
      error.push("DPP is empty");
    }

    // Validation Product
    let totalAmountProduct = 0;
    productList.forEach((item, index) => {
      totalAmountProduct += parseInt(item.item_actual || 0);
    });

    if (
      totalAmountProduct > 0 &&
      totalAmountProduct !== parseInt(this.removeSeparator(dpp))
    ) {
      error.push("Total actual of products must be 0 or equal with DPP");
    }

    console.log('INPUTED', documentList.length)
    console.log('REQUIRED', docs.length)
    if (documentList.length < docs.length) {
      error.push("Please complete the required attachments");
    } else {
      if (this.state.fileRequired.path == "") {
        error.push("Upload the required attachment");
      }
    }

    // Invoice Amount Validation
    if (this.state.paymentMethod === "INV") {
      let app = this;
      let countAmount = 0;
      selectedInvoice.map((item, index) => {
        let find = _.find(app.state.listInvoice, function (o) {
          return parseInt(o.CUSTOMER_TRX_ID) === parseInt(item.CUSTOMER_TRX_ID);
        });
        if (find) {
          item.CUSTOMER_TRX_ID = find.CUSTOMER_TRX_ID;
          item.INVOICE_DATE = moment(new Date(find.INVOICE_DATE)).format(
            "YYYY-MM-DD"
          );
          item.INVOICE_NUMBER = find.INVOICE_NUMBER;
          item.OUTSTANDING_AMOUNT = find.OUTSTANDING_AMOUNT;
          item.OUTSTANDING_FORMATTED = find.OUTSTANDING_FORMATTED;
          item.ADJUST = find.ADJUST;
          countAmount = parseInt(countAmount) + parseInt(item.ADJUST);
        }
        return item;
      });
      if (selectedInvoice.length === 0) {
        error.push("Please select invoice");
      }
      if (countAmount > parseInt(this.removeSeparator(totalAmount))) {
        error.push("The invoice amount cannot be higher than the total claims");
      }
    } else if (this.state.paymentMethod === "TRF") {
      if (!this.state.supplierId || this.state.supplierId === 0) {
        error.push("Please select supplier");
      }
      if (!this.state.supplierSite || this.state.supplierSite.length === 0) {
        error.push("Please select supplier site");
      }
    }

    if (this.state.skb === "Y") {
      if (!this.state.fileSKB.filename) {
        error.push("Please attach document for exemption certificate");
      }
      if (this.state.skbNumber.length === 0) {
        error.push("SKB Number is empty");
      }
    }

    if (error.length > 0) {
      window.scrollTo(0, 0);
      this.setState({ error: error });
      return false;
    } else {
      return true;
    }
  };
  handleSubmit = () => {
    if (this.validateForm()) {
      let url = "/api/traces/v1/claim/update";
      let {
        kwitansi,
        skbNumber,
        program_customer_id,
        supplier,
        supplierId,
        supplierSite,
        potongTagihan,
        pphRate,
        pphType,
        dpp,
        pph,
        ppn,
        totalAmount,
      } = this.state;
      let { id } = this.props.match.params;
      let param = {
        kwitansi: kwitansi,
        skbNumber: skbNumber,
        program_customer_id: program_customer_id,
        supplier: supplier,
        supplierId: supplierId,
        supplierSite: supplierSite,
        claim_id: id,
        potongTagihan: potongTagihan,
        pph_rate: pphRate,
        pph_type: pphType,
        dpp: this.removeSeparator(dpp),
        ppn: this.removeSeparator(ppn) || 0,
        pph: this.removeSeparator(pph),
        total: this.removeSeparator(totalAmount),
        fileContainer: this.state.docs,
        userId: this.state.user.user_id,
        invoice: this.state.selectedInvoice,
        paymentMethod: this.state.paymentMethod,
        norek: this.state.norek,
        npwp: this.state.header_npwp,
        skb: this.state.skb,
        fileSKB: this.state.fileSKB,
        fileLain: this.state.fileLain,
        fileTambahan: this.state.fileTambahan,
        taxNo: this.state.taxNo,
        taxDate: moment(this.state.taxDate).format("YYYY-MM-DD"),
        bankName: this.state.bankName,
        accOwner: this.state.accOwner,
        status: "D",
        product_list: this.state.productList,
        source: "infostep",
        menu: "claim",
        function: "update-reject",
      };

      this.setState({ loading: true });
      request.postTraces(url, param, {
        success: function (response) {
          this.setState({
            loading: false,
            success: "Claim submitted successfully",
          });
          window.scrollTo(0, 0);
          let app = this;
          window.setTimeout(() => {
            app.props.history.push("/admin/claim/reject");
          }, 2000);
        }.bind(this),
        error: function (e) {
          window.scrollTo(0, 0);
          this.setState({
            loading: false,
            error: ["Failed to submit, please try again"],
          });
        }.bind(this),
      });
    }
  };

  handleCheckInvoice = (e) => {
    let value = e.target.value;
    let isChecked = e.target.checked;
    let { selectedInvoice } = this.state;

    if (isChecked) {
      selectedInvoice.push({ CUSTOMER_TRX_ID: value });
    } else {
      let findIndex = _.findIndex(selectedInvoice, function (o) {
        return parseInt(o.CUSTOMER_TRX_ID) === parseInt(value);
      });
      selectedInvoice.splice(findIndex, 1);
    }
    this.setState(selectedInvoice);
    this.calculateCheckedInvoice();
  };

  calculateCheckedInvoice = () => {
    let total = 0;
    let app = this;
    this.state.selectedInvoice.forEach((item, index) => {
      let find = _.find(app.state.listInvoice, function (o) {
        return parseInt(o.CUSTOMER_TRX_ID) === parseInt(item.CUSTOMER_TRX_ID);
      });
      let adjusted = find ? find.ADJUST : 0;
      console.log(find);
      total = total + parseInt(adjusted);
    });
    this.setState({ totalSelectedAmount: this.thousandSeparator(total) });
  };

  renderTableInvoice = () => {
    if (this.state.paymentMethod === "INV") {
      let app = this;
      const data = {
        columns: [
          {
            Header: "",
            minWidth: 30,
            accessor: "CUSTOMER_TRX_ID",
            Cell: (row) => {
              let findIndex = _.findIndex(
                this.state.selectedInvoice,
                function (o) {
                  return parseInt(o.CUSTOMER_TRX_ID) === parseInt(row.value);
                }
              );
              let checked = findIndex >= 0 ? true : false;
              return (
                <input
                  type="checkbox"
                  value={row.value}
                  onChange={this.handleCheckInvoice.bind(this)}
                  checked={checked}
                />
              );
            },
          },
          {
            Header: "INVOICE NO",
            accessor: "INVOICE_NUMBER",
            filterable: true,
          },
          {
            Header: "INVOICE DATE",
            accessor: "INVOICE_DATE",
            Cell: (row) => (
              <span>
                <span>
                  {row.value !== null
                    ? moment(row.value).format("DD-MMM-YYYY")
                    : ""}
                </span>
              </span>
            ),
          },
          {
            Header: "BALANCE",
            accessor: "OUTSTANDING_AMOUNT",
            className: "text-right",
            Cell: function (row) {
              return <span>{app.thousandSeparator(row.value)}</span>;
            },
          },
          {
            Header: "ADJUSTMENT",
            accessor: "OUTSTANDING_AMOUNT",
            Cell: function (row) {
              let newValue = _.find(app.state.selectedInvoice, function (o) {
                return o.invoice_id === row.original.CUSTOMER_TRX_ID;
              });
              let adjustedAmount = newValue
                ? parseInt(newValue.invoice_amount)
                : 0;
              return (
                <span>
                  <span>{adjustedAmount}</span>
                </span>
              );
            },
          },
          {
            Header: "NEW ADJUSTMENT",
            accessor: "ADJUST",
            Cell: function (row) {
              // let newValue = _.find(app.state.selectedInvoice, function (o) {
              //   return o.invoice_id === row.original.CUSTOMER_TRX_ID;
              // });
              // let adjustedAmount = newValue
              //   ? parseInt(newValue.invoice_amount)
              //   : 0;
              return (
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={row.value}
                  data-outstanding={row.original.OUTSTANDING_AMOUNT}
                  data-trx-id={row.original.CUSTOMER_TRX_ID}
                  onChange={app.handleAdjust.bind(app)}
                />
              );
            },
          },
        ],
        rows: this.state.listInvoice,
      };
      return (
        <span>
          <h6>
            Total Amount Invoice Selected: {this.state.totalSelectedAmount}
          </h6>
          <ReactTable
            className="fullWidth"
            data={data.rows}
            columns={data.columns}
            defaultPageSize={10}
          />
        </span>
      );
    }
  };

  handleAdjust = (e) => {
    let value = e.target.value.replace(/[^0-9.]/g, "").replace(/\./g, "");
    let trxId = e.target.dataset.trxId;
    let outstanding = e.target.dataset.outstanding;
    let { listInvoice } = this.state;
    let findIndex = _.findIndex(listInvoice, function (o) {
      return parseInt(o.CUSTOMER_TRX_ID) === parseInt(trxId);
    });
    if (findIndex >= 0) {
      if (parseInt(value) > parseInt(outstanding)) {
        value = outstanding;
      }
      listInvoice[findIndex].ADJUST = value;
      this.setState(listInvoice);
      this.calculateCheckedInvoice();
    }
  };

  handleTaxDate = (date) => {
    this.setState({ taxDate: date });
  };

  renderTax = () => {
    let { ppn } = this.state;
    if (parseInt(ppn) !== 0) {
      return (
        <div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Tax No
            </label>
            <div className="col-sm-8">
              <input
                type="text"
                autoComplete="off"
                className="form-control"
                id="inputEmail3"
                name="taxNo"
                placeholder="Tax No"
                onChange={this.handleChangeInput.bind(this)}
                value={this.state.taxNo}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Tax Date
            </label>
            <div className="col-sm-8">
              <DatePicker
                selected={this.state.taxDate}
                dateFormat="d-MMM-yyyy"
                className="form-control"
                popperPlacement="top-end"
                onChange={this.handleTaxDate}
              />
            </div>
          </div>
        </div>
      );
    }
  };

  handleSKB = (e) => {
    let value = e.target.value;
    let isChecked = e.target.checked;
    let app = this;
    let { fileSKB } = this.state;
    fileSKB.filename = "";
    fileSKB.path = "";
    if (isChecked) {
      this.setState({ skb: value, pph: 0, showSkbAttachment: true });
    } else {
      this.setState({ skb: "N", showSkbAttachment: false });
      this.setState(fileSKB);
      this.countPPH();
    }
    window.setTimeout(() => {
      app.calculateAmount();
    }, 100);
  };

  handleRedirect = (e) => {
    e.preventDefault()
    const url = request.getFileS3('skb', this.state.fileContainer.filename);
    if (url && url.length > 0) {
      window.open(url, '_blank');
    }
  };

  renderSKBAttachment = () => {
    if (this.state.showSkbAttachment) {
      if (this.state.fileSKB.filename.length > 0) {
        return (
          <div className="col-md-8">
            {/* <Link to={{ pathname: this.state.fileSKB.path }} target="_blank">
              [view file]
            </Link> */}
            <a
              href="#"
              onClick={this.handleRedirect.bind(this)}
              target="blank"
              rel="noopener noreferrer"
            >
              [view file]
            </a>
            &nbsp;
            <button
              type="button"
              className="btn btn-link text-danger"
              onClick={this.handleRemoveSKB.bind(this)}
            >
              [delete]
            </button>
          </div>
        );
      } else {
        return (
          <div className="col-md-8">
            <input
              type="file"
              className="form-control"
              data-type="SKB"
              onChange={this.handleUploadSingle.bind(this)}
            />
          </div>
        );
      }
    }
  };

  renderSKBNumber = () => {
    if (this.state.skb === "Y") {
      return (
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            SKB Number
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              autoComplete="off"
              className="form-control"
              id="inputEmail3"
              name="skbNumber"
              placeholder=""
              onChange={this.handleChangeInput.bind(this)}
              value={this.state.skbNumber}
            />
          </div>
        </div>
      );
    }
  };

  handleRemoveSKB = () => {
    let { fileSKB } = this.state;
    fileSKB.filename = "";
    fileSKB.path = "";
    this.setState(fileSKB);
  };

  customerInfo = () => {
    // console.log(this.state.productList);
    return (
      <div className="row">
        <div className="col-md-6">
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Customer
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                autoComplete="off"
                disabled
                className="form-control"
                id="inputEmail3"
                name="customerName"
                placeholder=""
                // onChange={this.handleChangeInput.bind(this)}
                value={this.state.customerName}
              />
            </div>
          </div>

          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              NPWP Name
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                disabled
                autoComplete="off"
                className="form-control"
                id="inputEmail3"
                name="header_npwp_name"
                placeholder=""
                value={this.state.header_npwp_name}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Npwp Address
            </label>
            <div className="col-sm-9">
              <textarea
                autoComplete="off"
                disabled
                className="form-control"
                id="inputEmail3"
                name="headerNpwpAddress"
                placeholder=""
                value={this.state.header_npwp_address}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              NPWP / NIK
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                autoComplete="off"
                className="form-control"
                id="header_npwp"
                name="header_npwp"
                placeholder=""
                onChange={this.handleChangeInputNpwp.bind(this)}
                defaultValue={this.state.header_npwp}
              // header_npwp
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderDocumentV2 = () => {
    let { fileRequired } = this.state;
    if (!fileRequired.path || fileRequired.path == "") {
      return this.state.docs.map((item, index) => (
        <div className="row">
          <div className="col-md-6" key={index}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value={item.program_doc_id}
                onClick={this.handleClickDocument.bind(this)}
                id="defaultCheck1"
              />
              <label className="form-check-label" htmlFor="defaultCheck1">
                {item.document_name}
              </label>
            </div>
          </div>
        </div>
      ));
    } else {
      return this.state.docs.map((item, index) => (
        <div className="row">
          <div className="col-md-6" key={index}>
            <div className="">
              <label className="form-check-label" htmlFor="defaultCheck1">
                <i className="fa fa-check text-success" /> {item.document_name}
              </label>
            </div>
          </div>
        </div>
      ));
    }
  };

  handleClickDocument = (e) => {
    let is_checked = e.target.checked;
    let docId = e.target.value;
    let { documentList, fileRequired } = this.state;
    if (is_checked) {
      documentList.push({ program_doc_id: docId });
    } else {
      let getIndex = _.findIndex(documentList, function (o) {
        return parseInt(o.program_doc_id) === parseInt(docId);
      });
      documentList.splice(getIndex, 1);
    }
    this.setState(documentList);
  };

  downloadAttachment = (data, preview) => {
    this.setState({ loading: true });
    let url =
      data.doc === "bupot"
        ? `/api/traces/v1/tracking-email/download-surat-refund?bupot_file_key=${data.key}&bupot_filename=${data.filename}`
        : data.doc === "mandatory"
          ? `/api/traces/v1/tracking-email/download-surat-refund?mandatory_filename=${data.filename}&mandatory_file_key=${data.key}`
          : `/api/traces/v1/tracking-email/download-surat-refund?additional_FileName=${data.filename}&mandatory_file_key=${data.key}`;

    request.getTraces(url, {
      success: function (response) {
        if (response.data.statusCode === 400) {
          window.open(data.path, "_blank");
          this.setState({ loading: false });
        } else {
          axios({
            url: response.config.url,
            method: "GET",
            responseType: "blob",
            headers: {
              Authorization: `Bearer ${tracesToken()}`,
            },
          })
            .then((response) => {
              if (preview && preview === "preview") {
                const objectUrl = URL.createObjectURL(response.data);
                const pdfWindow = window.open();
                pdfWindow.location.href = objectUrl;
                // window.open(response.config.url, "_blank");
                this.setState({ loading: false });
              } else {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement("a");
                link.href = href;
                link.setAttribute(
                  "download",
                  data.doc === "bupot"
                    ? `CLAIM_${data.claim_id}.pdf`
                    : data.doc === "mandatory"
                      ? `${data.claim_number.replace(/[/]/g, "")}.pdf`
                      : `${data.filename}.pdf`
                );
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
                this.setState({ loading: false });
              }
            })
            .catch((error) => {
              window.open(data.path, "_blank");
              this.setState({ loading: false });
            });
        }
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  previewFile = (e) => {
    const objectUrl = URL.createObjectURL(e)
    const pdfWindow = window.open();
    pdfWindow.location.href = objectUrl;
  }

  previewFileAdditional = (e) => {
    const objectUrl = URL.createObjectURL(e)
    const pdfWindow = window.open();
    pdfWindow.location.href = objectUrl;
  }

  renderUploadSingle = (type) => {
    if (type === "REQUIRED") {
      if (this.state.fileRequired.path && this.state.fileRequired.path != "") {
        if (this.state.editable == true) {
          return (
            <span>
              {
                this.state.newFile ?
                  <Link to='#' onClick={() => this.previewFile(this.state.newFile)}>
                    {this.state.newFile.name}
                  </Link>
                  :
                  <Link to={"#"} onClick={() => this.downloadAttachment(this.state.fileRequired, 'preview')}>
                    {this.state.fileRequired.filename}
                  </Link>
              }
              &nbsp;{" "}
              {
                this.state.newAdditionalFile ?
                  '' :
                  <Button type="primary" icon={<DownloadOutlined />} className="ml-3" onClick={() => this.downloadAttachment(this.state.fileRequired)} />
              }
              <Button danger type="primary" icon={<DeleteOutlined />} className="ml-3" onClick={this.handleRemoveFile.bind(this, "ADDITIONAL")} />
            </span>
          );
        } else {
          return (
            <span>
              {
                this.state.newFile ?
                  <Link to='#' onClick={() => this.previewFile(this.state.newFile)}>
                    {this.state.newFile.name}
                  </Link>
                  :
                  <>
                    <Link to={"#"} onClick={() => this.downloadAttachment(this.state.fileRequired, 'preview')}>
                      {this.state.fileRequired.filename}
                    </Link>
                    <Button type="primary" icon={<DownloadOutlined />} className="ml-3" onClick={() => this.downloadAttachment(this.state.fileRequired)} />
                  </>
              }
            </span>
          );
        }
      } else {
        if (this.state.documentList.length === this.state.docs.length) {
          return (
            <div className="row mt-2">
              <div className="col-md-12">
                <input
                  type="file"
                  className="form-control"
                  data-type="REQUIRED"
                  onChange={this.handleUploadSingle.bind(this)}
                />
                <small>(*) merge all files before uploading</small>
              </div>
            </div>
          );
        }
      }
    } else if (type === "ADDITIONAL") {
      if (
        this.state.fileTambahan.path &&
        this.state.fileTambahan.path.length > 0
      ) {
        if (this.state.editable == true) {
          return (
            <span>
              {
                this.state.newAdditionalFile ?
                  <Link to='#' onClick={() => this.previewFileAdditional(this.state.newAdditionalFile)}>
                    {this.state.newAdditionalFile.name}
                  </Link>
                  :
                  <Link to={"#"} onClick={() => this.downloadAttachment(this.state.fileTambahan, 'preview')}>
                    {this.state.fileTambahan.filename}
                  </Link>
              }
              &nbsp;{" "}
              {
                this.state.newAdditionalFile ?
                  '' :
                  <Button type="primary" icon={<DownloadOutlined />} className="ml-3" onClick={() => this.downloadAttachment(this.state.fileTambahan)} />
              }
              <Button danger type="primary" icon={<DeleteOutlined />} className="ml-3" onClick={this.handleRemoveFile.bind(this, "ADDITIONAL")} />
            </span>
          );
        } else {
          return (
            <span>
              {
                this.state.newAdditionalFile ?
                  <Link to='#' onClick={() => this.previewFileAdditional(this.state.newAdditionalFile)}>
                    {this.state.newAdditionalFile.name}
                  </Link>
                  :
                  <>
                    <Link to={"#"} onClick={() => this.downloadAttachment(this.state.fileTambahan, 'preview')}>
                      {this.state.fileTambahan.filename}
                    </Link>
                    <Button type="primary" icon={<DownloadOutlined />} className="ml-3" onClick={() => this.downloadAttachment(this.state.fileTambahan)} />
                  </>
              }
            </span>
          );
        }
      }
      if (this.state.additionalAttachment) {
        return (
          <div className="row mt-2">
            <div className="col-md-12">
              <input
                type="file"
                className="form-control"
                data-type="TAMBAHAN"
                onChange={this.handleUploadSingle.bind(this)}
              />
            </div>
          </div>
        );
      }
    }
  };

  renderDocumentAdditional = () => {
    let { fileTambahan } = this.state;
    if (fileTambahan.path == "") {
      return (
        <div className="row">
          <div className="col-md-6">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value={1}
                name="additionalAttachment"
                onClick={this.handleClickAdditional.bind(this)}
                id="defaultCheck1"
              />
              <label className="form-check-label" htmlFor="defaultCheck1">
                Additional
              </label>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="row">
          <div className="col-md-6">
            <div className="">
              <label className="form-check-label" htmlFor="defaultCheck1">
                Additional
              </label>
            </div>
          </div>
        </div>
      );
    }
  };

  handleClickAdditional = (e) => {
    let is_checked = e.target.checked;
    let { fileTambahan } = this.state;
    if (is_checked) {
      this.setState({ additionalAttachment: 1 });
    } else {
      fileTambahan.filename = "";
      fileTambahan.path = "";
      this.setState({ additionalAttachment: 0 });
      this.setState(fileTambahan);
    }
  };

  handleRemoveFile = (type) => {
    let { fileTambahan, fileRequired, documentList } = this.state;
    if (type === "REQUIRED") {
      fileRequired.filename = "";
      fileRequired.path = "";
      this.setState(fileRequired);
      this.setState({ documentList: [] });
    } else if (type === "ADDITIONAL") {
      fileTambahan.filename = "";
      fileTambahan.path = "";
      this.setState(fileTambahan);
      this.setState({ additionalAttachment: 0 });
    }
  };

  renderClaimInfo = () => {
    return (
      <div className="card">
        <div className="card-header font-size-title bg-light font-weight-bold">
          Claim Info
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Payment Method</label>
                <div className="col-sm-8 mt-2">
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" checked={this.state.paymentMethod === "INV" ? true : false} type="radio" name="paymentMethod" id="inlineRadio1" value="INV" onChange={this.handleChangeInput.bind(this)} />
                    <label className="form-check-label" htmlFor="inlineRadio1" >Deduct to receivable</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" checked={this.state.paymentMethod === "TRF" ? true : false} type="radio" name="paymentMethod" id="inlineRadio2" value="TRF" onChange={this.handleChangeInput.bind(this)} />
                    <label className="form-check-label" htmlFor="inlineRadio2">Transfer</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" checked={this.state.paymentMethod === "DEP" ? true : false} type="radio" name="paymentMethod" id="inlineRadio1" value="DEP" onChange={this.handleChangeInput.bind(this)} />
                    <label className="form-check-label" htmlFor="inlineRadio1">Deposit</label>
                  </div>
                </div>
              </div>
              {this.renderNorek()}
              <div className="form-group row">
                <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Customer PPh Type</label>
                <div className="col-sm-8">
                  {this.renderLovPPh()}
                </div>
              </div>
              <div className="form-group row">
                <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Rate <small>(%)</small></label>
                <div className="col-sm-3">
                  <input type="text" autoComplete="off" max="100" min="0" className="form-control" id="inputEmail3" name="pphRate" placeholder="" onChange={this.handleChangeInput.bind(this)} value={this.state.pphRate} />
                </div>
              </div>
              <div className="form-group row">
                <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">DPP</label>
                <div className="col-sm-8">
                  <input type="text" autoComplete="off" className="form-control" id="inputEmail3" name="dpp" placeholder="" onChange={this.handleChangeInput.bind(this)} value={this.state.dpp} />
                </div>
              </div>
              <div className="form-group row">
                <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">PPN</label>
                <div className="col-sm-8">
                  <input type="text" autoComplete="off" className="form-control" id="inputEmail3" name="ppn" placeholder="" onChange={this.handleChangeInput.bind(this)} value={this.state.ppn} />
                </div>
              </div>
              {this.renderTax()}
              <div className="form-group row">
                <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">SKB</label>
                <div className="col-sm-1 mt-2">
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="checkbox" checked={this.state.skb === "Y" ? true : false} name="skb" id="inlineRadio1" value="Y" onChange={this.handleSKB.bind(this)} />
                  </div>
                </div>
                {this.renderSKBAttachment()}
              </div>
              {this.renderSKBNumber()}
              <div className="form-group row">
                <label htmlFor="inputEmail3" className="col-sm-4 col-form-label" >PPh</label>
                <div className="col-sm-8">
                  <input type="text" autoComplete="off" disabled={this.state.showSkbAttachment} className="form-control" id="inputEmail3" name="pph" placeholder="" onChange={this.handleChangeInput.bind(this)} value={this.state.pph} />
                </div>
              </div>
              <div className="form-group row">
                <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Total Claim</label>
                <div className="col-sm-8">
                  <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" name="totalAmount" placeholder="" onChange={this.handleChangeInput.bind(this)} value={this.state.totalAmount} />
                </div>
              </div>
              <div className="form-group row">
                <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Customer Receipt No.</label>
                <div className="col-sm-8">
                  <input type="text" autoComplete="off" className="form-control" id="inputEmail3" name="kwitansi" placeholder="" onChange={this.handleChangeInput.bind(this)} value={this.state.kwitansi} />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              {this.renderTableInvoice()}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderProductList = () => {
    return (
      <div className="card">
        <div className="card-header font-size-title bg-light font-weight-bold">
          Products
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Product Description</label>
              <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">Product Reff</label>
              <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">Product Budget</label>
              <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">Actual</label>
              {this.renderProduct()}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderAttachments = () => {
    return (
      <div className="card">
        <div className="card-header font-size-title bg-light font-weight-bold">Attachments</div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              {this.renderDocumentV2()}
              {this.renderUploadSingle("REQUIRED")}
            </div>
            <div className="col-md-6">
              {this.renderDocumentAdditional()}
              {this.renderUploadSingle("ADDITIONAL")}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderReason = () => {
    return (
      <div className="card">
        <div className="card-header font-size-title bg-light font-weight-bold">
          Reason
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-4">
              <textarea className="form-control" rows="5" placeholder="Reason" disabled onChange={this.handleChangeInput.bind(this)} name="reason" value={this.state.reason} ></textarea>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-body">
                    {this.showError()}
                    {this.showSuccess()}
                    <form className="form-horizontal">
                      <GeneralInfo data={this.state} />
                      <CustomerInfo data={this.state} is_edit={true} onChangeNPWP={this.handleChangeNPWP.bind(this)} />
                      {this.renderClaimInfo()}
                      {this.renderProductList()}
                      {this.renderAttachments()}
                      {this.renderReason()}
                      <div className="clearfix">&nbsp;</div>
                      <div className="row">
                        <div className="col-md-4">
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={this.handleSubmit.bind(this)}
                          >
                            <i className="fas fa-file-upload"></i> Submit
                          </button>
                          &nbsp;
                          <button
                            type="button"
                            className="btn btn-warning"
                            onClick={() => {
                              this.props.history.push(
                                "/admin/claim/summary-assignment"
                              );
                            }}
                          >
                            <i className="fas fa-arrow-left"></i> Back
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Detail;
